import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/pages/Home/Home'
import Tools from '@/components/pages/Tools/Tools'
import SignIn from '@/components/pages/SignIn'
import SignUp from '@/components/pages/SignUp'
import Responses from '@/components/pages/Responses'
import Training from '@/components/pages/Training'
import Profile from '@/components/pages/Profile/Profile'
import Verification from '@/components/pages/Home/Verification'
import {isSignedIn, isSignedInAndVerified} from './auth-gaurd'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: isSignedInAndVerified
    },
    {
      path: '/verify',
      name: 'Verify Account',
      component: Verification,
      beforeEnter: isSignedIn
    },
    {
      path: '/tools',
      name: 'Tools',
      component: Tools,
      beforeEnter: isSignedInAndVerified
    },
    {
      path: '/training',
      name: 'Training',
      component: Training,
      beforeEnter: isSignedInAndVerified
    },
    {
      path: '/responses',
      name: 'Responses',
      component: Responses,
      beforeEnter: isSignedInAndVerified
    },
    {
      path: '/signin',
      name: 'Sign In',
      component: SignIn
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: isSignedIn
    },
    {
      path: '/signup',
      name: 'Sign Up',
      component: SignUp
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js